import React from 'react';

import { useGlobalization } from '@Translations';
import { TextField, ToggleButton } from '@mui/material';
import { Visibility, VisibilityOff } from '@mui/icons-material';

export interface VisiblePasswordProps {
	value: string;
	passwordError: string;
	textFieldChanged: (event: React.FormEvent) => void;
}

export const VisiblePasswordField = (props: VisiblePasswordProps) => {
	const { t } = useGlobalization();

	const [passwordVisible, setPasswordVisible] = React.useState(false);

	const userEnteredPassword = () => {
		return props.value !== '••••••••';
	};

	return (
		<TextField
			color={'primary'}
			fullWidth
			margin={'normal'}
			label={t('Password')}
			required={true}
			variant="outlined"
			name={'password'}
			type={passwordVisible ? 'text' : 'password'}
			InputProps={{
				endAdornment: userEnteredPassword() && (
					<ToggleButton
						value="check"
						style={{ border: 'none' }}
						selected={false}
						onChange={() => {
							setPasswordVisible(!passwordVisible);
						}}>
						{passwordVisible ? <VisibilityOff /> : <Visibility />}
					</ToggleButton>
				),
			}}
			value={props.value ?? ''}
			onChange={props.textFieldChanged}
			error={!!props.passwordError}
			helperText={props.passwordError}
		/>
	);
};
